import React, { useState } from 'react';
import MonitorImage from './MonitorImage';
import Modal from 'react-modal';
import _ from 'lodash';

Modal.setAppElement('#root');

export default function ImageGallery({ monitor, isViewAll}) {
  const [isOpen, setIsOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalImage('');
  };

  return (
    <div className={`grid grid-cols-2  gap-3 ${isViewAll ? "md:grid-cols-3" : ""}`}>
      {!_.isEmpty(monitor) ? (
        monitor.map((item) => (
          <MonitorImage
            key={item.Id}
            alt={`Monitor ${item.Id}`}
            onClick={() => openModal(item.ImageUrl)}
            item={item}  
          />
        ))
      ) : (
        <p className="col-span-3 text-center">No monitors available.</p>
      )}

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Image Modal"
        className="flex items-center justify-center p-5"
        overlayClassName="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center"
      >
        <div className="relative bg-transparent rounded-lg  p-4 max-w-3xl w-full">
          <button
            onClick={closeModal}
            className="absolute -top-2 -right-2 text-gray-50"
          >
            <svg
              className="w-8 h-8"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          {modalImage && (
            <img src={modalImage} alt="Full View" className="w-full h-auto" />
          )}
        </div>
      </Modal>
    </div>
  );
}
